import { jsx as _jsx } from "react/jsx-runtime";
import { HeroBlock } from "./hero";
export function HeroCenteredBlock({ data, ...props }) {
    return _jsx(HeroBlock, { ...props, data: { ...data, variant: "center" } });
}
/**
 * The stored block, mapped to what the component wants.
 *
 * Identical to `heroFromBlock` except that it reads no `variant` scalar: the
 * schema declares none, and this component would ignore it anyway.
 */
export function heroCenteredFromBlock(block) {
    const scalars = block.scalars ?? {};
    return {
        eyebrow: scalars.eyebrow?.trim() || undefined,
        title: scalars.heading || scalars.title || "",
        description: scalars.subheading || scalars.description || undefined,
    };
}
export const heroCenteredBlockEntry = {
    Component: HeroCenteredBlock,
    fromBlock: heroCenteredFromBlock,
};
//# sourceMappingURL=hero-centered.js.map